import { ThemeProvider } from "@emotion/react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import NormalButton from "components/atoms/Button/NormalButton";
import PriceStr from 'components/atoms/String/PriceStr';
import React from 'react';



const colortheme = createTheme({
    palette: {
        primary: {
            main: "#292739",
        },
    },
    typography: {
        fontFamily: ["lato"].join(","),
    },
});

const ParaText = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    color: "#ffffff",
}));

const SmallText = styled(Typography)(({ theme }) => ({
    fontSize: ".8rem",
    color: "#ffffff",
}));

const TitleText = styled(Typography)(({ theme }) => ({
    fontSize: "2.4rem",
    fontWeight: "bold",
    color: "#ffffff",
}));

const ButtonFooter = () => {

    return (
        <React.Fragment>
            <ThemeProvider theme={colortheme}>
                <Box>
                    <Box sx={{margin: "2rem 0rem"}}>
                        <TitleText style={{ margin: "1rem 0", fontSize: "1.6rem" }}>
                            How the funding works
                        </TitleText>
                        <ParaText style={{ color: "#c1c1c1" }}>
                            You will receive an invite for the next fund session around 2 weeks before the event. It will occur online: the only thing you’ll need to do is to login on our app and follow the instructions you will receive from us.
                        </ParaText>
                    </Box>

                    <Box sx={{margin: "2rem 0rem"}}>
                        <TitleText style={{ margin: "1rem 0", fontSize: "1.6rem" }}>
                            Next funding session
                        </TitleText>
                        <ParaText style={{ color: "#c1c1c1" }}>
                            March 21st, 2022
                        </ParaText>
                    </Box>

                    <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                        <Grid item xs={12}>
                            <NormalButton style={{ width: "100%" }}>
                                <ParaText>
                                    <PriceStr />
                                    <br />
                                    <SmallText>
                                        $8,123
                                    </SmallText>
                                </ParaText>
                            </NormalButton>
                        </Grid>
                    </Grid>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    );
};

export default ButtonFooter;
